import React from 'react';
import { BlockDataForm } from '@plone/volto/components';
import { BannerBlockSchema } from './schema';
import { useIntl } from 'react-intl';

const BannerBlockData = (props) => {
  const { data, block, onChangeBlock, contentType, navRoot } = props;
  const intl = useIntl();
  const schema = BannerBlockSchema({ ...props, intl });

  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      formData={data}
      block={block}
      navRoot={navRoot}
      contentType={contentType}
    />
  );
};

export default BannerBlockData;
